class MatchShotsIndividualVisualController {
  constructor(
    MatchesFactory,
    LeaguesFactory,
    $rootScope,
    $filter,
    $state,
    $stateParams,
    URLS,
    $window,
    $timeout,
    $scope
  ) {
    "ngInject";
    const vm = this;

    let $translate = $filter("translate");

    vm.rootScope = $rootScope;
    vm.$onInit = () => {
      if ($stateParams.matchId) {
        vm.matchId = parseInt($stateParams.matchId);
      }
      if ($stateParams.olympicMatchId) {
        vm.olympicMatchId = parseInt($stateParams.olympicMatchId);
      }
      if ($stateParams.leagueId) {
        vm.leagueId = parseInt($stateParams.leagueId);
      }
      $state.current.data.hideSidebar = true;
      $state.current.data.hideMatchProfile = true;
      $state.current.data.hideMatchMenu = true;
      vm.leagues = [];
      vm.matchLeagues = [];
      vm.activeLeague = null;
      vm.roundsTemplate = ["1/32", "1/16", "1/8", "1/4", "1/2", "1/1"];
      vm.rounds = [];
      vm.activeRound = null;

      vm.activeEliminationMatches = [];
      vm.activeEliminationMatch = null;
      vm.roundOneShots = {};
      vm.roundTwoShots = {};
      vm.shotsHeaders = [
        { name: "#", class: "col-xs-1" },
        { name: "1ο", class: "col-xs-1" },
        { name: "2ο", class: "col-xs-1" },
        { name: "3ο", class: "col-xs-1" },
        { name: "Shot", class: "col-xs-1" },
        { name: "Score", class: "col-xs-1" },
        { name: "#", class: "col-xs-1" },
        { name: "1ο", class: "col-xs-1" },
        { name: "2ο", class: "col-xs-1" },
        { name: "3ο", class: "col-xs-1" },
        { name: "Shot", class: "col-xs-1" },
        { name: "Score", class: "col-xs-1" },
      ];
      vm.maxShots = 6;
      reloadLeagueEliminationMatch();
      if (vm.olympicMatchId) {
        setInterval(() => {
          reloadLeagueEliminationMatch();
        }, 3000);
      }
    };

    vm.getPlayerImage = (img) => {
      if (img) {
        return URLS.IMAGES_URL + "/players/" + img;
      } else {
        return "assets/images/no_avatar.png";
      }
    };

    vm.isLeagueCompound = () => {
      return (
        vm.activeEliminationMatch.leagueType ===
        LeaguesFactory.LEAGUE_TYPES.COMPOUND
      );
    };

    vm.isLeagueRecurve = () => {
      return (
        vm.activeEliminationMatch.leagueType ===
        LeaguesFactory.LEAGUE_TYPES.RECURVE
      );
    };

    vm.isLeagueField = () => {
      return (
        vm.activeEliminationMatch.leagueType ===
        LeaguesFactory.LEAGUE_TYPES.FIELD
      );
    };

    vm.selectEliminationMatch = (olympicMatchId) => {
      vm.activeEliminationMatch = vm.eliminationMatches.find(
        (el) => el.olympic_match_id === olympicMatchId
      );
      vm.reUpdateAfterEliminationMatchChange();
    };

    vm.reUpdateAfterEliminationMatchChange = () => {
      vm.roundOneShots = {};
      vm.roundTwoShots = {};
      vm.roundOneFinalShot = null;
      vm.roundTwoFinalShot = null;
      vm.roundOneFinalShotTwo = null;
      vm.roundTwoFinalShotTwo = null;
      vm.roundOneCloseToCenter = null;
      vm.roundTwoCloseToCenter = null;
      vm.activeRoundOne = vm.activeEliminationMatch.rounds[0];
      vm.activeRoundTwo = vm.activeEliminationMatch.rounds[1];
      if (vm.isLeagueCompound()) {
        if (
          vm.activeRoundOne.points === "bye" ||
          vm.activeRoundTwo.points === "bye"
        ) {
          vm.activeRoundOne.displayScore = vm.activeRoundOne.points;
          vm.activeRoundTwo.displayScore = vm.activeRoundTwo.points;
        } else {
          vm.activeRoundOne.displayScore = parseInt(vm.activeRoundOne.points);
          vm.activeRoundTwo.displayScore = parseInt(vm.activeRoundTwo.points);
          if (vm.activeRoundOne.arrow_f) {
            vm.activeRoundOne.displayScore += parseInt(
              vm.activeRoundOne.arrow_f
            );
          }
          if (vm.activeRoundTwo.arrow_f) {
            vm.activeRoundTwo.displayScore += parseInt(
              vm.activeRoundTwo.arrow_f
            );
          }
        }
      } else {
        vm.activeRoundOne.displayScore = vm.activeRoundOne.points;
        vm.activeRoundTwo.displayScore = vm.activeRoundTwo.points;
      }
      for (let i = 1; i < vm.maxShots; i++) {
        vm.roundOneShots[i] = {
          arrows: {
            1: vm.activeRoundOne["arrow_" + i + "_1"],
            2: vm.activeRoundOne["arrow_" + i + "_2"],
            3: vm.activeRoundOne["arrow_" + i + "_3"],
          },
          stats: {
            endScore: 0,
            score: 0,
          },
        };
        vm.roundTwoShots[i] = {
          arrows: {
            1: vm.activeRoundTwo["arrow_" + i + "_1"],
            2: vm.activeRoundTwo["arrow_" + i + "_2"],
            3: vm.activeRoundTwo["arrow_" + i + "_3"],
          },
          stats: {
            endScore: 0,
            score: 0,
          },
        };
      }
      vm.roundOneFinalShot = vm.activeRoundOne["arrow_f"];
      vm.roundTwoFinalShot = vm.activeRoundTwo["arrow_f"];
      vm.roundOneFinalShotTwo = vm.activeRoundOne["arrow_f_2"];
      vm.roundTwoFinalShotTwo = vm.activeRoundTwo["arrow_f_2"];
      vm.roundOneCloseToCenter = vm.activeRoundOne["closer_to_center"] === 1;
      vm.roundTwoCloseToCenter = vm.activeRoundTwo["closer_to_center"] === 1;
      vm.calculateArrows();
    };

    vm.calculateArrows = () => {
      vm.roundOneScore = 0;
      vm.roundTwoScore = 0;
      for (let i = 1; i < 4; i++) {
        vm.roundOneShots[i].stats.score = 0;
        vm.roundTwoShots[i].stats.score = 0;
      }
      for (let i = 1; i <= vm.maxShots; i++) {
        let shotOneScore = 0;
        let shotTwoScore = 0;
        if (i === vm.maxShots) {
          shotOneScore = parseInt(vm.roundOneFinalShot);
          shotTwoScore = parseInt(vm.roundTwoFinalShot);
        } else {
          for (let j = 1; j < 4; j++) {
            if (!vm.roundOneShots[i].arrows[j]) {
              continue;
            }

            /* Round One */
            if (vm.roundOneShots[i].arrows[j] == 0) {
              vm.roundOneShots[i].arrows[j] = "m";
            }
            if (vm.roundOneShots[i].arrows[j].toLowerCase() !== "m") {
              shotOneScore =
                shotOneScore + parseInt(vm.roundOneShots[i].arrows[j]);
            }
            /* Round Two */
            if (!vm.roundTwoShots[i].arrows[j]) {
              continue;
            }
            if (vm.roundTwoShots[i].arrows[j] == 0) {
              vm.roundTwoShots[i].arrows[j] = "m";
            }
            if (vm.roundTwoShots[i].arrows[j].toLowerCase() !== "m") {
              shotTwoScore =
                shotTwoScore + parseInt(vm.roundTwoShots[i].arrows[j]);
            }
          }
          vm.roundOneShots[i].stats.endScore = shotOneScore;
          vm.roundTwoShots[i].stats.endScore = shotTwoScore;
          if (!vm.roundOneShots[i].arrows[3]) {
            continue;
          }
          if (!vm.roundTwoShots[i].arrows[3]) {
            continue;
          }
        }
        /* RECURVE SCORING */
        if (vm.isLeagueRecurve() || vm.isLeagueField()) {
          // if(vm.activeLeague.type === LeaguesFactory.LEAGUE_TYPES.RECURVE){
          /* iF shoot off */
          if (i === vm.maxShots) {
            if (vm.roundOneFinalShot && vm.roundTwoFinalShot) {
              if (shotOneScore > shotTwoScore) {
                vm.roundOneScore += 2;
              } else if (shotOneScore < shotTwoScore) {
                vm.roundTwoScore += 2;
              }
            }
          } else {
            if (shotOneScore > shotTwoScore) {
              vm.roundOneShots[i].stats.score = 2;
              vm.roundOneScore += 2;
            } else if (shotOneScore < shotTwoScore) {
              vm.roundTwoShots[i].stats.score = 2;
              vm.roundTwoScore += 2;
            } else if (shotOneScore && shotTwoScore) {
              vm.roundOneShots[i].stats.score = 1;
              vm.roundOneScore++;
              vm.roundTwoShots[i].stats.score = 1;
              vm.roundTwoScore++;
            }
          }
        } else {
          /* COMPOUND SCORING */
          /* iF shoot off */
          if (i === vm.maxShots) {
            if (vm.roundOneFinalShot && vm.roundTwoFinalShot) {
              vm.roundOneScore += shotOneScore;
              vm.roundTwoScore += shotTwoScore;
            }
          } else {
            vm.roundOneScore += shotOneScore;
            vm.roundOneShots[i].stats.score = vm.roundOneScore;
            vm.roundTwoScore += shotTwoScore;
            vm.roundTwoShots[i].stats.score = vm.roundTwoScore;
          }
        }
      }
    };

    vm.selectEliminationMatchAndRemove = async () => {
      if (vm.eliminationMatches.length > 0) {
        let eliminationMatchId = vm.eliminationMatches[0].olympic_match_id;
        let activeEliminationMatchResponse = await MatchesFactory.getOne(
          vm.matchId,
          {
            include: "matchOlympicIndividual,matchLeagues",
            league_id: vm.leagueId,
            olympic_match_id: eliminationMatchId,
          },
          true
        );

        $scope.$apply(() => {
          vm.activeEliminationMatch =
            activeEliminationMatchResponse.data.matchOlympicIndividual.find(
              (m) => m.olympic_match_id === eliminationMatchId
            );
          vm.reUpdateAfterEliminationMatchChange();
          vm.eliminationMatches = [...vm.eliminationMatches.slice(1)];
        });

        $timeout(() => {
          vm.selectEliminationMatchAndRemove();
        }, 10000);
      } else {
        $window.location.reload();
      }
    };

    vm.playerOneTarget = () => {
      let target = "";
      if (vm.activeEliminationMatch) {
        let round = vm.activeEliminationMatch.rounds.find(
          (r) => r.player_id === vm.activeEliminationMatch.playerOne.player_id
        );
        if (round) {
          return round.target_name;
        }
      }
      return target;
    };

    vm.playerTwoTarget = () => {
      let target = "";
      if (vm.activeEliminationMatch) {
        let round = vm.activeEliminationMatch.rounds.find(
          (r) => r.player_id === vm.activeEliminationMatch.playerTwo.player_id
        );
        if (round) {
          return round.target_name;
        }
      }
      return target;
    };

    function reloadLeagueEliminationMatch() {
      let data = {
        include: "matchOlympicIndividual,matchLeagues",
      };
      if (!!vm.leagueId) {
        data.league_id = vm.leagueId;
      }
      if (!!vm.olympicMatchId) {
        data.olympic_match_id = vm.olympicMatchId;
      }
      vm.eliminationMatches = [];
      MatchesFactory.getOne(vm.matchId, data, true).then((response) => {
        vm.activeMatch = response.data;
        vm.eliminationMatches = [...response.data.matchOlympicIndividual];
        vm.matchLeagues = [...response.data.matchLeagues];
        if (vm.olympicMatchId) {
          vm.selectEliminationMatch(vm.olympicMatchId);
        } else {
          vm.eliminationMatches = [];
          vm.matchLeagues.map((league) => {
            if (!!league.currentIndividualRound) {
              vm.eliminationMatches = [
                ...vm.eliminationMatches,
                ...response.data.matchOlympicIndividual.filter((m) => {
                  return (
                    m.round === league.currentIndividualRound &&
                    m.league_id === league.league_id &&
                    m.player_1_score !== "bye" &&
                    m.player_2_score !== "bye"
                  );
                }),
              ];
            }
          });
          vm.selectEliminationMatchAndRemove();
        }
      });
    }
  }
}

export default MatchShotsIndividualVisualController;



// WEBPACK FOOTER //
// ./client/app/components/matches/matchProfile/matchShotsIndividualVisual/matchShotsIndividualVisual.controller.js